<script lang="ts">
  import type { Snippet } from "svelte"

  import { SidebarInset } from "@/components/ui/sidebar"

  interface Props {
    variant?: "header" | "sidebar"
    class?: string
    children?: Snippet
  }

  let { variant, class: className, children }: Props = $props()
</script>

{#if variant === "sidebar"}
  <SidebarInset class={className}>
    {@render children?.()}
  </SidebarInset>
{:else}
  <main
    class="mx-auto flex h-full w-full max-w-7xl flex-1 flex-col gap-4 rounded-xl {className ||
      ''}"
  >
    {@render children?.()}
  </main>
{/if}
